import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

export default function ctaService () {

	// Skip containers already initialised (eg. re-running after an ACF
	// block preview refresh in the editor - see hook below)
	const swipers = document.querySelectorAll('section.cta-service .swiper:not(.swiper-initialized)');

	if (! swipers.length) return;



	// Init swiper
	swipers.forEach(function (container) {

		const section = container.closest('section');

		new Swiper (container, {
			modules: [Navigation, Pagination],
			loop: false,
			/*
				Fractional slidesPerView (partial slide peeking on the right)
				would otherwise clamp the last position so the wrapper's right
				edge is flush with the container's right edge, breaking the
				grid rhythm - the last slide ends up NOT left-aligned like all
				the others. snapToSlideEdge fixes this (same option RBK's own
				post-services.js already uses for its fractional 1.3 swipers).
			*/
			snapToSlideEdge: true,
			spaceBetween: 24,
			/*
				slidesPerView values are derived from the .container width at
				each breakpoint (768/1004/1344px) so the card itself stays
				~318px wide (Figma's own Portrait Image Card width) up to lg -
				only the visible count grows. From lg up (container caps at
				1344px, then 1664px at xl) slidesPerView holds at ~4.15 so a
				partial next card always peeks in on the right edge, per design.
			*/
			breakpoints: {
				0:    { slidesPerView: 1.2 },
				540:  { slidesPerView: 1.6 },
				768:  { slidesPerView: 2.3 },
				1024: { slidesPerView: 3 },
				1364: { slidesPerView: 4.15 },
			},
			pagination: {
				el: section.querySelector('.swiper-pagination'),
				type: 'progressbar',
			},
			navigation: {
				prevEl: section.querySelector('.swipe-prev'),
				nextEl: section.querySelector('.swipe-next'),
			},
		});

	});

}



/*
	ACF Blocks v3 re-fetches and re-renders this block's preview markup
	inside the editor (eg. on attribute change) without a page reload, so
	'DOMContentLoaded' only covers the first render - re-run init on every
	preview refresh too. ACF's block-preview JS may run in the iframe's own
	window or in the parent admin window depending on context, so check both.
*/
const acfInstance = (typeof window !== 'undefined')
	? (window.acf || (window.parent !== window && window.parent.acf))
	: null
;

if (acfInstance) {
	acfInstance.addAction('render_block_preview/type=cta-service', ctaService);
}
